<!-- Barra de navegación -->
<nav class="navbar navbar-expand-lg navbar-dark bg-dark animate__animated fadeIn position-fixed w-100">
  <a class="navbar-brand font-weight-bolder text-white" href="#">EAZZY</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
    aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link small" (click)="scrollTo('home')">Inicio</a>
      </li>
      <li class="nav-item">
        <a class="nav-link small" (click)="scrollTo('contact')">Contáctanos</a>
      </li>
    </ul>
  </div>
</nav>
<div class="container bg-dark h-25">
</div>

<!-- Seccion de inicio -->
<section id="home">
  <div class="row h-100 bg-dark">
    <div class="col-lg-6 d-flex">
      <div class="content mx-auto align-self-center px-4 my-5">
        <small class="d-block text-white mb-3"><span class="badge bg-primary mr-2 text-white">NEW!</span>Tenemos una mejor forma de manejar tu menú.
        </small>
        <h1 class="display-4 font-weight-bold mb-4 text-white">EAZZY hace de tu menú tu mejor aliado.</h1>
        <p class="lead mb-4 text-white">Dile adiós a las cartas aburridas y sin identidad.</p>
        <a href='https://linktr.ee/eazzyclub' target="_blank" class="btn btn-primary mb-5 rounded-pill">Conoce EAZZY</a>
      </div>
    </div>
    <div class="col-lg-6 d-flex bg-dark">
      <div class="content mx-auto align-self-center px-4 my-5">
        <img src="../../../../assets/landing/principal.jpg" class="img-fluid rounded">
      </div>
    </div>
  </div>
</section>

<!-- Seccion se servicios -->
<section id="services" class="bg-dark">
  <h2 class="text-white text-center">Conoce nuestros módulos</h2>
  <div class="row h-100 bg-dark p-4">
    <div class="col-lg-4 d-flex">
      <div class="card border-0 mb-2">
        <img class="card-img-top" src="../../../../assets/landing/rufinaPhone.jpg" alt="Card image cap">
        <div class="card-body">
          <h3 class="card-title text-dark">Administrador carta digital</h3>
          <p class="card-text">Controla el contenido de tu menú en tiempo real, agrega publicidades propias, aplica tu manual de imagen, maneja la disponibilidad de tus productos,
            entre otras cosas mas.</p>
          <a href="https://firebasestorage.googleapis.com/v0/b/sinmente-4bfad.appspot.com/o/uploads%2Feazzy%2FEazzy.pdf?alt=media&token=19ef8d86-a8f7-4e76-9b9f-20f1733b91a1"
            target="_blank" class="btn btn-dark rounded-pill">Conocer mas</a>
        </div>
      </div>
    </div>
    <div class="col-lg-4 d-flex">
      <div class="card border-0 mb-2">
        <img class="card-img-top" src="../../../../assets/landing/landingReserve.jpg" alt="Card image cap">
        <div class="card-body">
          <h3 class="card-title text-dark">Plataforma de reservas</h3>
          <p class="card-text">Con Eazzy tus clientes podrán reservar un lugar en tu establecimiento en 3 simples pasos y tendrás control de la información en tiempo real.
            Notificaciones via SMS y correo de confirmación.</p>
          <a href="https://firebasestorage.googleapis.com/v0/b/sinmente-4bfad.appspot.com/o/uploads%2Feazzy%2FReservas.pdf?alt=media&token=f87aeba7-c9c6-4e34-a021-f3fa9a66b12a"
            target="_blank" class="btn btn-dark rounded-pill">Conocer mas</a>
        </div>
      </div>
    </div>
    <div class="col-lg-4 d-flex">
      <div class="card border-0 mb-2">
        <img class="card-img-top" src="../../../../assets/landing/landingRoom.jpg" alt="Card image cap">
        <div class="card-body">
          <h3 class="card-title text-dark">Plataforma de room service</h3>
          <p class="card-text">Plataforma dedicada a la Hotelería, con este módulo podrás brindarle una plataforma de pedidos a tus clientes donde seleccionaran sus productos y
            desde eazzy controlar el estado del pedido hasta su preparación.</p>
        </div>
      </div>
    </div>
  </div>
</section>


<!-- Seccion de contacto -->
<section class="d-flex py-5" id="contact" class="section-contact">
  <div class="container align-self-center">
    <div class="bg-light call-to-action rounded">
      <div class="row">
        <div class="col-lg-6 d-flex">
          <div class="align-self-center p-5">
            <h2 class="display-4 fw-bold mb-4 text-dark">Cuéntale a EAZZY sobre tu establecimiento</h2>
            <p class="lead mb-4 text-dark">Estamos para escucharte y apoyarte, para que tengas el control al 100% sobre las interfaces digitales que le ofreces a tus clientes.</p>
            <a href='https://www.canva.com/design/DAEpjBq9m8E/V3c0_KYZDH0eE4ZfnR4tug/view?utm_content=DAEpjBq9m8E&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h5bde7286d3'
              target="_blank" class="btn btn-dark mb-5 rounded-pill">Conoce EAZZY</a>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="row">
            <div class="col-12 form-sec">
              <h2 class="text-center text-dark">Escríbenos</h2>
              <form class="form-form" [formGroup]="emailForm" (ngSubmit)="onSubmit()">
                <div class="form-group">
                  <label>Nombre y apellido *</label>
                  <input type="text" class="form-control rounded-pill" formControlName="full_name"
                    [ngClass]="{'is-invalid': emailForm.controls.full_name.invalid &&  emailForm.controls.full_name.touched}">
                  <div class="invalid-feedback">
                    Debe ingresar un nombre.
                  </div>
                </div>
                <div class="form-group">
                  <label>Correo *</label>
                  <input type="text" class="form-control rounded-pill" formControlName="email"
                    [ngClass]="{'is-invalid': emailForm.controls.email.invalid &&  emailForm.controls.email.touched}">
                  <div class="invalid-feedback">
                    Debe ingresar un correo válido.
                  </div>
                </div>
                <div class="form-group">
                  <label>Teléfono *</label>
                  <input type="number" class="form-control rounded-pill" formControlName="phone_number"
                    [ngClass]="{'is-invalid': emailForm.controls.phone_number.invalid &&  emailForm.controls.phone_number.touched}">
                  <div class="invalid-feedback">
                    Debe ingresar un número de teléfono válido.
                  </div>
                </div>

                <div class="form-group">
                  <label>Mensaje</label>
                  <textarea class="form-control rounded-pill" formControlName="message" rows="3"></textarea>
                </div>
                <div class="row">
                  <div class="col-12">
                    <button [disabled]="!emailForm.valid" type="submit" class="btn btn-form float-right btn-block btn-primay rounded-pill">Enviar</button>
                  </div>
                </div>
                <div class="row mt-2 animate__animated bounceInUp" *ngIf="isShowAlert">
                  <div class="col-12">
                    <div class="alert alert-success" role="alert">
                      Mensaje enviado con exito
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section id="clients" class="bg-dark">
  <h2 class="text-white text-center">Algunas de las marcas que confían en EAZZY</h2>
  <div class="row p-4">
    <div class="col-lg-12 bg-light d-flex">
      <ul class="list-group list-group-horizontal list-group-flush overflow-auto align-items-center">
        <li class="list-group-item" *ngFor="let client of clients">
          <img [src]="client.image" alt="" style="width: 10rem;" class="rounded">
          <p class="font-weight-bold text-dark">{{client.name}}</p>
        </li>
      </ul>
    </div>
  </div>
</section>

<!-- <section id="hero">
  <div class="row g-0 h-100">
    <div class="col-lg-6 d-flex">
      <div class="content mx-auto align-self-center px-4 my-5">
        <small class="d-block text-primary mb-3"><span class="badge bg-primary me-2">Nuevo</span>Adquiere nuestra nueva tarjeta de crédito.
        </small>
        <h1 class="display-4 fw-bold mb-4">La mejor banca digital<span class="text-primary">.</span></h1>
        <p class="lead mb-4">Dile adiós a los bancos tradicionales y disfruta todos los beneficios de un banco 100% digital.</p>
        <a href="#" class="btn btn-primary mb-5">Abre tu cuenta hoy</a>
        <div class="d-flex">
          <div class="d-flex me-4">
            <img src="logo-apple.svg" class="me-3">
            <div>
              <small>Consíguela en</small>
              <p class="fw-bold mb-0">App Store</p>
            </div>
          </div>
          <div class="d-flex">
            <img src="logo-playstore.svg" class="me-3">
            <div>
              <small>Disponible en</small>
              <p class="fw-bold mb-0">Play Store</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6 d-flex bg-light">
      <div class="content mx-auto align-self-center px-4 my-5">
        <img src="phone.png" class="img-fluid">
      </div>
    </div>
  </div>
</section>

<section class="d-flex py-6">
  <div class="container align-self-center">
    <div class="row">
      <div class="col-lg-6">
        <div class="content mx-auto px-4 my-5">
          <img src="image-1.png" class="img-fluid">
        </div>
      </div>
      <div class="col-lg-6 d-flex">
        <div class="align-self-center my-5 px-4">
          <h2 class="display-4 fw-bold mb-5">Haz que crezca
            tu dinero<span class="text-primary">.</span></h2>

          <ul class="list-unstyled mb-0">
            <li class="d-flex mb-4">
              <p class="lead fw-bold text-primary d-flex step">1</p>
              <div class="ms-3">
                <p class="lead fw-bold">Crea tu cuenta.</p>
                <p>Es muy sencillo, solamente ingresa tu
                  celular y listo.</p>
              </div>
            </li>
            <li class="d-flex mb-4">
              <p class="lead fw-bold text-primary d-flex step">2</p>
              <div class="ms-3">
                <p class="lead fw-bold">Solicita tu tarjeta personalizada.</p>
                <p>Selecciona el color que más te guste para tu tarjeta,
                  la enviaremos a tu domicilio.</p>
              </div>
            </li>
            <li class="d-flex mb-4">
              <p class="lead fw-bold text-primary d-flex">3</p>
              <div class="ms-3">
                <p class="lead fw-bold">Activa tu tarjeta y empieza a utilizarla.</p>
                <p>Inicia sesión en la app e ingresa el número de tarjeta.</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>



<section class="d-flex py-5">
  <div class="container align-self-center">
    <h2 class="display-4 fw-bold">Educación Financiera<span class="text-primary">.</span></h2>
    <p class="lead mb-5">Comienza a aprender con nuestros artículos</p>
    <div class="row gx-5">
      <div class="col-lg-4 py-4">
        <a href="#" class="text-decoration-none">
          <img src="blog-01.jpg" class="img-fluid mb-4">
          <div class="d-flex mb-4">
            <p class="flex-grow-1 text-dark mb-0">12 de febrero 2021</p>
            <p class="text-dark mb-0">Créditos</p>
          </div>
          <p class="lead text-dark fw-bold mb-4">Que debes saber antes de tramitar un crédito hipotecario</p>
          <p class="text-primary fw-bold">Leer más <i class="fas fa-arrow-right ms-2"></i></p>
        </a>
      </div>
      <div class="col-lg-4 py-4">
        <a href="#" class="text-decoration-none">
          <img src="blog-02.jpg" class="img-fluid mb-4">
          <div class="d-flex mb-4">
            <p class="flex-grow-1 text-dark mb-0">8 de febrero 2021</p>
            <p class="text-dark mb-0">Inversión</p>
          </div>
          <p class="lead text-dark fw-bold mb-4">Te damos 5 razones para invertir en la Bolsa de Valores</p>
          <p class="text-primary fw-bold">Leer más <i class="fas fa-arrow-right ms-2"></i></p>
        </a>
      </div>
      <div class="col-lg-4 py-4">
        <a href="#" class="text-decoration-none">
          <img src="blog-03.jpg" class="img-fluid mb-4">
          <div class="d-flex mb-4">
            <p class="flex-grow-1 text-dark mb-0">2 de febrero 2021</p>
            <p class="text-dark mb-0">Emprendedor</p>
          </div>
          <p class="lead text-dark fw-bold mb-4">Alcanza la libertad financiera antes de los 30</p>
          <p class="text-primary fw-bold">Leer más <i class="fas fa-arrow-right ms-2"></i></p>
        </a>
      </div>
    </div>
  </div>
</section>

<section class="d-flex pt-5 pb-0 h-100">
  <div class="container align-self-center">
    <div class="bg-primary text-light text-center p-5 rounded w-75 mx-auto mb-5">
      <h2 class="display-4 fw-bold">Abre tu cuenta hoy</h2>
      <p class="lead">Es rápidoo y sencillo, solo te tomará menos de 5 minutos</p>
      <div class="cta-form position-relative mx-auto d-none d-md-block">
        <input type="email" class="form-control" placeholder="Correo electrónico">
        <button type="submit" class="btn btn-primary position-absolute">Abre tu cuenta hoy</button>
      </div>
      <div class="d-md-none">
        <input type="email" class="form-control mb-3" placeholder="Correo electrónico">
        <button type="submit" class="btn btn-light w-100">Abre tu cuenta hoy</button>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-lg-3 col-sm-6 my-4">
        <h5 class="fw-bold mb-3">Productos</h5>
        <ul class="list-unstyled">
          <li class="mb-3"><a href="" class="text-dark text-decoration-none">Tarjetas de crédito</a></li>
          <li class="mb-3"><a href="" class="text-dark text-decoration-none">Tarjetas de débito</a></li>
          <li><a href="" class="text-dark text-decoration-none">Crédito hipotecario</a></li>
        </ul>
      </div>
      <div class="col-lg-3 col-sm-6 my-4">
        <h5 class="fw-bold mb-3">Productos</h5>
        <ul class="list-unstyled">
          <li class="mb-3"><a href="" class="text-dark text-decoration-none">Tarjetas de crédito</a></li>
          <li class="mb-3"><a href="" class="text-dark text-decoration-none">Tarjetas de débito</a></li>
          <li><a href="" class="text-dark text-decoration-none">Crédito hipotecario</a></li>
        </ul>
      </div>
      <div class="col-lg-3 col-sm-6 my-4">
        <h5 class="fw-bold mb-3">Productos</h5>
        <ul class="list-unstyled">
          <li class="mb-3"><a href="" class="text-dark text-decoration-none">Tarjetas de crédito</a></li>
          <li class="mb-3"><a href="" class="text-dark text-decoration-none">Tarjetas de débito</a></li>
          <li><a href="" class="text-dark text-decoration-none">Crédito hipotecario</a></li>
        </ul>
      </div>
      <div class="col-lg-3 col-sm-6 my-4">
        <h5 class="fw-bold mb-3">Banca digital</h5>
        <ul class="list-unstyled">
          <li class="mb-3">Avenida Paseo de la Reforma 296</li>
          <li>
            <ul class="list-inline">
              <li class="list-inline-item me-3"><a href="" class="lead text-dark"><i class="fab fa-facebook"></i></a></li>
              <li class="list-inline-item me-3"><a href="" class="lead text-dark"><i class="fab fa-instagram"></i></a></li>
              <li class="list-inline-item"><a href="" class="lead text-dark"><i class="fab fa-linkedin"></i></a></li>
            </ul>
          </li>
        </ul>
      </div>
    </div>


  </div>
</section> -->

<!-- Footer -->
<div class="border-top py-4 container">
  <div class="row">
    <div class="col-lg-6 col-md-12">
      <small>2021. EAZZY Colombia. Todos los derechos reservados</small>
    </div>
    <div class="col-lg-6 col-md-12">
      <ul class="list-inline text-lg-end">
        <li class="list-inline-item"><a href="#" class="text-dark text-decoration-none"><small>Términos y condiciones</small></a></li>
        <li class="list-inline-item"><a href="#" class="text-dark text-decoration-none"><small>Aviso de privacidad</small></a></li>
      </ul>
    </div>
  </div>
</div>